import { fetchCampaign } from '../actions';
import Loading from 'components/UI/LoadingScreen/index';
import ScrollToTop from 'components/UI/ScrollToTop/index';
import { ProductContext, ProductGrid } from 'product';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { getProductsFromIds } from 'utilities/product';
import './CampaignPage.scss';
import CampaignHeader from '../components/CampaignHeader';
import CampaignBlockList from '../components/CampaignBlockList';
import { Helmet } from 'react-helmet';
function CampaignPage({ campaign, products, isMobile, isLoading, notFound }) {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchCampaign());
    }, []);
    const { t } = useTranslation();
    if (isLoading || !campaign)
        return React.createElement(Loading, null);
    if (notFound)
        return (React.createElement("div", { className: "campaign-page" },
            React.createElement("p", null, t('campaignPageNotFound'))));
    const campaignProducts = getCampaignProducts(campaign, products);
    const { image, text, page_header, block, title_text_color, background_color } = campaign;
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("title", null,
                page_header,
                " - Morgenlevering"),
            React.createElement("meta", { property: "og:title", content: `${page_header} - Morgenlevering` }),
            React.createElement("meta", { property: "og:url", content: `https://morgenlevering.no/campaign/${campaign.slug}` })),
        React.createElement("div", { className: "campaign-page" },
            React.createElement(ScrollToTop, null),
            React.createElement(CampaignHeader, { title: page_header, image: isMobile ? image.mobile : image.desktop, textColor: title_text_color, backgroundColor: background_color, type: "page" }),
            React.createElement(CampaignBlockList, { blocks: block }),
            React.createElement("div", { className: "campaign-page__text", dangerouslySetInnerHTML: { __html: text } }),
            campaignProducts && campaignProducts.length > 0 && (React.createElement("div", { className: "campaign-page__products" },
                React.createElement("h2", null, t('campaignPageProductsHeader')),
                React.createElement(ProductContext.Provider, { value: `CampaignPage_${campaign.slug}` },
                    React.createElement(ProductGrid, { products: campaignProducts })))))));
}
function mapStateToProps(state, { match }) {
    const slug = match.params.slug;
    const currentCampaign = getCampaignFromSlug(state.campaign.campaigns, slug);
    return {
        campaign: currentCampaign,
        products: state.products.products,
        notFound: state.campaign.error || !currentCampaign,
        isMobile: state.ui.isMobile,
        isLoading: state.products.productsLoading,
    };
}
function getCampaignFromSlug(campaigns, slug) {
    return campaigns.filter((c) => c.slug === slug)[0];
}
function getCampaignProducts(campaign, products) {
    if (!campaign)
        return [];
    return campaign.products ? getProductsFromIds(campaign.products, products) : [];
}
export default connect(mapStateToProps)(CampaignPage);
